import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import ForecastArchiveDocumentContent from "./ForecastArchiveDocumentContent/ForecastArchiveDocumentContent.js";
import ForecastArchiveDocumentCoordinator from "./ForecastArchiveDocumentCoordinator.js";
import ForecastArchiveDocumentService from "./ForecastArchiveDocumentService.js";
import ForecastArchiveDocumentState from "./ForecastArchiveDocumentState.js";
import ForecastArchiveTitleWidget from "./widgets/ForecastArchiveTitleWidget/ForecastArchiveTitleWidget.js";
import session from "../../core/session.js";

/**
 * Create and return a new forecast editor document and everything
 * that this document requires.
 */
export default function makeForecastArchiveDocument() {
	const coordinator = new ForecastArchiveDocumentCoordinator({
		documentState: new ForecastArchiveDocumentState({
			service: new ForecastArchiveDocumentService({ session }),
			canCurrentUserDeleteForecasts: session
				.getCurrentUser()
				.canAdministrateForecastsFor(session.getCompany()),
		}),
		renderables: {
			content: new ForecastArchiveDocumentContent(),
			title: new ForecastArchiveTitleWidget(),
			periodPicker: false,
		},
	});

	return new AccountingDocument({ coordinator });
}
